import dayjs from 'dayjs';

export interface IBrand {
  id?: string;
  name?: string | null;
  description?: string | null;
  category?: string | null;
  logo?: string | null;
  coverPhoto?: string | null;
  isDraft?: boolean | null;
  createdAt?: dayjs.Dayjs | null;
  updatedAt?: dayjs.Dayjs | null;
}

export const defaultValue: Readonly<IBrand> = {
  isDraft: false,
};
